var _ = require('lodash'),
  BinObject = require('../models/binObject'),
  BinProfilingObject = require('../models/binObject').ProfilingObject,
  cache = require('../models/cache'),
  configManager = require('../config/configManager'),
  CONST_EVENTS = require('../constants/events'),
  CONST_MESSAGES = require('../constants/messages'),
  events = require('../events/eventObserver'),
  dfUtility = require('../utilities/deviceFingerprinterUtility'),
  GetConfiguration = require('../messages/DeviceFingerprinter/binEnabled'),
  log = require('../libraries/logger').getLoggerInstance('Base.DF'),
  RSVP = require('rsvp');

var privateMethods = {

  messageProcessors: {
    profileComplete: {
      browser: function (messageObject) {
        log.debug("Received browser profileComplete message from DF");
        if ('Results' in messageObject) {
          var cardinalDataResults = _.find(messageObject.Results, function (entry) {
            return entry.DataSource === CONST_MESSAGES.DEVICE_FINGERPRINT.PROFILE_COMPLETE.DATA_SOURCE.CARDINAL_DATA
          }), publishData;

          log.debug('DF profiling times: ' + JSON.stringify(messageObject.Results) + "for nonce [" + messageObject.nonce + "]");

          if (cardinalDataResults !== undefined) {
            log.debug("DF Profiling is marked as " + (cardinalDataResults.Status ? "successful" : "failed"));
            events.publish(CONST_EVENTS.INTERNAL.DF_BROWSER_PROFILING_COMPLETED, false, cardinalDataResults.Status);
          } else {
            log.debug("Unable to find a CardinalData object on browser profile.complete, marking as failed.")
            events.publish(CONST_EVENTS.INTERNAL.DF_BROWSER_PROFILING_COMPLETED, false, false);
          }

          publishData = {
            Results: messageObject.Results,
            Type: 'profiling',
            Source: 'browser'
          }
          events.passive.publish(CONST_EVENTS.METRICS_NOTIFY, publishData);
        }
      },
      bin: function (messageObject) {
        log.debug("Received bin profileComplete message from DF");
        if ('Results' in messageObject) {
          var threatMetrixData, publishData;
          log.debug('DF profiling times: ' + JSON.stringify(messageObject.Results));

          threatMetrixData = _.find(messageObject.Results, function (entry) {
            return entry.DataSource === CONST_MESSAGES.DEVICE_FINGERPRINT.PROFILE_COMPLETE.DATA_SOURCE.THREAT_METRIX
          });

          if (threatMetrixData !== undefined) {
            log.debug("Bin profiling is marked as " + (threatMetrixData.Status ? "successful" : "failed"));
            events.publish(CONST_EVENTS.INTERNAL.DF_BIN_PROFILING_COMPLETED, false, messageObject.Nonce, threatMetrixData.Status);
          } else {
            log.debug("Unable to find a ThreatMetrix object on bin profile.complete, marking as failed.")
            events.publish(CONST_EVENTS.INTERNAL.DF_BIN_PROFILING_COMPLETED, false, false);
          }

          publishData = {
            Results: messageObject.Results,
            Type: 'profiling',
            Source: 'bin'
          }
          events.passive.publish(CONST_EVENTS.METRICS_NOTIFY, publishData);
        }
      }
    }
  },

},
  publicMethods = {
    /**
     * A helper to determine if bin profiling needs to be run or not. If it does need to be run
     * or is already running it will wait for the configured bin delay time before resolving the returned promise.
     * @param {String=} bin - Optional bin value that was collected
     * @returns {PromiseLike} - A promise that is resolved when you should move forward with the flow
     */
    ensureBinDetectionFinished: function (bin) {
      return new RSVP.Promise(function (resolve, reject) {
        try {
          if (bin !== undefined && bin !== '') {
            var binData = dfUtility.binCacheUtility.find(bin);

            if (binData !== undefined && binData.profiling.required === true && !binData.profiling.completed) {
              // need to wait..
              log.debug('Bin detection already running, waiting to complete..');
              events.timeboxSubscribe(CONST_EVENTS.INTERNAL.DF_BIN_PROFILING_COMPLETED, 4000)
                .catch(function () {
                  // We want to catch a timeout and the transaction to continue. We return false to indicate
                  // the time expired before completion
                  return false;
                })
                .then(function (profilingStatus) {
                  log.debug("bin profiling was " + (profilingStatus ? 'successful' : 'a failure') + " continuing with transaction");
                  resolve();
                })
            } else if (binData === undefined) {
              // new bin to profile
              log.debug('Found unprofiled bin on request, checking to see if bin requires profiling..');
              return publicMethods.profileBin(bin)
                .catch(function (error) {
                  log.warn('Failed to profile bin on the fly during a transaction: ' + error);
                })
                .then(function () {
                  resolve();
                })
            } else {
              // continue
              resolve();
            }
          } else {
            // Its possible that the transaction is using tokenization
            log.debug("No bin found on order, skipping bin profiling");
            resolve();
          }
        } catch (error) {
          reject(error);
        }
      })
    },
    /**
     * A message router for handling post message requests from device fingerprint
     * @param {Object} messageObject The event.data that was passed through on the post message
     */
    messageReceiver: function (messageObject) {
      if (messageObject !== undefined && 'MessageType' in messageObject && messageObject.MessageType !== '') {
        switch (messageObject.MessageType) {
          case 'profile.complete':
            if ('Source' in messageObject && messageObject.Source !== '') {
              switch (messageObject.Source) {
                case 'browser':
                  privateMethods.messageProcessors.profileComplete.browser(messageObject);
                  break;
                case 'bin':
                  privateMethods.messageProcessors.profileComplete.bin(messageObject);
                  break;
                default:
                  log.error('Unknown source found on profile.complete request [' + messageObject.Source + ']');
              }
            }

            break;
          default:
            log.debug("Unsupported message receieved from DF: " + JSON.stringify(messageObject));
            break;
        }
      }
    },
    /**
     * A orchistration helper to complete bin profiling. This method will create and inject an iframe and submit the bin 
     * to DF and wait for the post back on completion. If the system bin delay timeout is exceeded the promise will reject.
     * @param {string} bin The bin to profile if needed
     * @returns {PromiseLike} a promise that resolves when the bin profile process completes successfully or rejects when it fails
     */
    profileBin: function (bin) {
      return publicMethods.shouldBinBeProfiled(bin)
        .then(function (binDetails) {
          if (binDetails.profiling.required && !binDetails.profiling.completed) {
            return dfUtility.createCollectionFrame(cache.deviceFingerprinting.urls.profileBin)
              .then(function (iframe) {
                return dfUtility.postBinCollectionFrame(cache.deviceFingerprinting.urls.profileBin, iframe, binDetails);
              })
              .then(function () {
                return dfUtility.waitForProfilingToComplete(binDetails);
              })
          }
        })
    },
    profileOnInit: function () {
      return new RSVP.Promise(function (resolve, reject) {
        try {
          var dfUrl = cache.deviceFingerprinting.urls.browser,
            dfStartTimer = new Date(),
            binData;

          return dfUtility.createCollectionFrame(dfUrl)
            .then(function (collectionIframe) {
              // Inject collect frame
              var bin = dfUtility.getBin();

              if (bin !== undefined) {
                // If we have a bin at the point we're doing device collection for the first time
                // we will assume the bin requires profiling
                var profilingObject = new BinProfilingObject(true);
                binData = dfUtility.binCacheUtility.create(bin, profilingObject);

                // POST /Browser/Data
                return dfUtility.postBinCollectionFrame(dfUrl, collectionIframe, binData);
              } else {
                // Simple DF Get /Browser/Render call
                collectionIframe.src = dfUrl;
                document.body.appendChild(collectionIframe);
              }
            })
            .finally(function () {
              // Wait for frame to tell us its done profiling
              events.timeboxSubscribe(CONST_EVENTS.INTERNAL.DF_BROWSER_PROFILING_COMPLETED, configManager.getSystemConfig().deviceProfilingTimeout)
                .catch(function () {
                  log.error('Device profiling did not complete in [' + configManager.getSystemConfig().deviceProfilingTimeout + ']ms');
                  reject({
                    Type: 'timeout'
                  });
                })
                .then(function (completedStatus) {
                  log.debug("Browser device profiling completed in [" + (new Date().getTime() - dfStartTimer.getTime()) + "]ms")
                  if (completedStatus) {
                    if (binData !== undefined) {
                      binData.profiling.completed = true;
                      dfUtility.binCacheUtility.update(binData);
                    }
                    resolve();
                  } else {
                    reject({
                      Type: 'DF Status Flag'
                    });
                  }
                })
            });

        } catch (error) {
          log.error('Failed while attempting to run DF on Init: ' + error);
          reject(error);
        }
      })
    },
    /**
     * Event handler to trigger bin profiling based off of button presses in an input field
     * @param {event} event - The event object passed in when listening to a DOM event
     */
    profileBinFromInput: function (event) {
      try {
        var element = event.target,
          binValue;

        if (element !== undefined && element !== null && element.value !== undefined && element.value !== '') {
          if (element.value.length >= 6) {
            // INSIGHT - with profile as you type, we want the profiling to occur as quickly as possible, so we will wait only for the bin before running profiling. This may result in less exact bin profiling to occur
            binValue = element.value;
            // INSIGHT - We only need to profile a bin once
            var binInCache = dfUtility.binCacheUtility.find(binValue);
            if (binInCache === undefined) {
              cache.bin = binValue;
              publicMethods.profileBin(binValue)
                .catch(function () {
                  log.error("Failed to profile bin using the input listener");
                })
            }
          }
        }
      } catch (error) {
        log.debug('event ' + (event != undefined ? 'was' : 'was not') + ' defined'); // eslint-disable-line eqeqeq
        log.debug('element ' + (event.target != undefined ? 'was' : 'was not') + ' found with a type of [' + event.target.type + ']'); // eslint-disable-line eqeqeq
        log.error('Exception while attempting to profile bin value from input' + error);
      }

    },
    /**
     * Checks to see if a given bin has a configuration at DeviceFingerpinter. A configuration means that the bin should be profiled, otherwise the profiling step can be skipped. If any error occurs we default to profiling. The promise is rejected if a bin was not found to check eligibility.
     * The request results are stored into the binCache to we don't need to make an additional request if the same bin comes through again.
     * @param {String=} bin - The bin to check for profiling configurations. If no bin is supplied we will attempt to find the bin set in cache
     * @returns {PromiseLike<BinObject>} A flag to indicate profiling should be completed
     */
    shouldBinBeProfiled: function (bin) {
      return new RSVP.Promise(function (resolve, reject) {
        var binData, failedBinData;
        try {

          if (bin === undefined) {
            if (cache.bin === undefined) {
              bin = cache.bin = dfUtility.getBin();
            } else {
              bin = cache.bin;
            }
          }

          // Initialized our default return value on error
          failedBinData = new BinObject(bin);

          if (bin !== undefined) {
            binData = dfUtility.binCacheUtility.find(bin);
            if (binData === undefined) {
              GetConfiguration.process(bin, cache.orgUnitId)
                .then(function (binProfilingEnabledResponse) {
                  var binProfilingDelay, defaultMethodUrlDelay = configManager.getSystemConfig().defaultMethodUrlDelay, profilingDetails, profilingDelay;
                  log.debug('Bin ' + (binProfilingEnabledResponse.ConfigsEnabled ? 'requires' : 'does not require') + ' profiling.');
                  log.debug('MethodURL ' + (binProfilingEnabledResponse.MethodUrlEnabled ? 'is' : 'is not') + ' required to run');

                  if (binProfilingEnabledResponse.ProfilingDelay !== undefined) {
                    binProfilingDelay = binProfilingEnabledResponse.ProfilingDelay;
                    if (_.isNaN(binProfilingDelay) || binProfilingDelay <= 0) {
                      binProfilingDelay = configManager.getSystemConfig().defaultBinProfilingDelay;
                    }
                  } else {
                    binProfilingDelay = configManager.getSystemConfig().defaultBinProfilingDelay;
                  }

                  profilingDetails = new BinProfilingObject();
                  profilingDetails.required = binProfilingEnabledResponse.ConfigsEnabled || binProfilingEnabledResponse.MethodUrlEnabled;

                  if (binProfilingEnabledResponse.ConfigsEnabled && !binProfilingEnabledResponse.MethodUrlEnabled) {
                    profilingDelay = binProfilingDelay;
                  } else if (!binProfilingEnabledResponse.ConfigsEnabled && binProfilingEnabledResponse.MethodUrlEnabled) {
                    profilingDelay = defaultMethodUrlDelay;
                  } else {
                    // If we have both bin configs and method url we need to use the wait time that is longest
                    profilingDelay = binProfilingDelay > defaultMethodUrlDelay ? binProfilingDelay : defaultMethodUrlDelay;
                  }

                  profilingDetails.delay = profilingDelay;

                  binData = dfUtility.binCacheUtility.create(bin, profilingDetails);

                  resolve(binData);
                })['catch'](function (error) {
                  log.error('Get Bin Configuration failed: ' + JSON.stringify(error));
                  resolve(failedBinData);
                });
            } else {
              resolve(binData);
            }

          } else {
            reject('No bin found to check for profiling eligibility.');
          }

        } catch (error) {
          log.error('Failure: ' + error);
          resolve(failedBinData);
        }
      });
    },
  };

events.subscribe(CONST_EVENTS.INTERNAL.DF_REQUEST_RECEIVED, publicMethods.messageReceiver)

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./libraries/deviceFingerprinting.js
// module id = 59
// module chunks = 5